import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { CurriculumTreeConceptInterface } from '../../+models';
import { CurriculumTreeConceptsActions, CurriculumTreeConceptsActionTypes } from './curriculum-tree-concept.actions';

export const NAME = 'curriculumTreeConcepts';

export interface State extends EntityState<CurriculumTreeConceptInterface> {
  // additional entities state properties
  loaded: boolean;
  error?: any;
}

export const adapter: EntityAdapter<CurriculumTreeConceptInterface> =
  createEntityAdapter<CurriculumTreeConceptInterface>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  loaded: false,
});

export function reducer(state = initialState, action: CurriculumTreeConceptsActions): State {
  switch (action.type) {
    case CurriculumTreeConceptsActionTypes.AddCurriculumTreeConcept: {
      return adapter.addOne(action.payload.curriculumTreeConcept, state);
    }

    case CurriculumTreeConceptsActionTypes.UpsertCurriculumTreeConcept: {
      return adapter.upsertOne(action.payload.curriculumTreeConcept, state);
    }

    case CurriculumTreeConceptsActionTypes.AddCurriculumTreeConcepts: {
      return adapter.addMany(action.payload.curriculumTreeConcepts, state);
    }

    case CurriculumTreeConceptsActionTypes.UpsertCurriculumTreeConcepts: {
      return adapter.upsertMany(action.payload.curriculumTreeConcepts, state);
    }

    case CurriculumTreeConceptsActionTypes.UpdateCurriculumTreeConcept: {
      return adapter.updateOne(action.payload.curriculumTreeConcept, state);
    }

    case CurriculumTreeConceptsActionTypes.UpdateCurriculumTreeConcepts: {
      return adapter.updateMany(action.payload.curriculumTreeConcepts, state);
    }

    case CurriculumTreeConceptsActionTypes.DeleteCurriculumTreeConcept: {
      return adapter.removeOne(action.payload.id, state);
    }

    case CurriculumTreeConceptsActionTypes.DeleteCurriculumTreeConcepts: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case CurriculumTreeConceptsActionTypes.CurriculumTreeConceptsLoaded: {
      return adapter.setAll(action.payload.curriculumTreeConcepts, {
        ...state,
        loaded: true,
      });
    }

    case CurriculumTreeConceptsActionTypes.CurriculumTreeConceptsLoadError: {
      return { ...state, error: action.payload, loaded: false };
    }

    case CurriculumTreeConceptsActionTypes.ClearCurriculumTreeConcepts: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
